import React from 'react';
import {Avatar} from 'antd';
import {UserOutlined} from '@ant-design/icons';

const ExceedAvatarComponent = ({imageUrl, size = 'large', shortcut, shape = "circle"}) => {
    if (imageUrl) {
        return <Avatar size={size} shape={shape} src={imageUrl}/>
    } else if (shortcut) {
        return <Avatar size={size} shape={shape}>{shortcut}</Avatar>
    } else {
        return <Avatar size={size} shape={shape} icon={<UserOutlined/>}/>;
    }
}

export default ExceedAvatarComponent;